module.exports = __webpack_public_path__ + "static/introduction-to-electrodynamics-9be8ae8b8c2cf82c5071e2e76cdfe960.jpg";